import { all, AllEffect, fork, ForkEffect } from "redux-saga/effects";

import watchAirlinesProductivitySagas from "./airlines_productivity/sagas";
import watchAirlinesSagas from "./airlines/sagas";
import watchAlertsSagas from "./alerts/sagas";
import watchAuctionSagas from "./auction/sagas";
import watchAuthSagas from "./auth/sagas";
import watchBookingsSagas from "./bookings/sagas";
import watchClicksSagas from "./clicks/sagas";
import watchContactPageSagas from "./contact/sagas";
import watchConversionsSagas from "./conversions/sagas";
import watchCurrenciesSagas from "./currencies/sagas";
import watchDebugSagas from "./debug/sagas";
import watchExtendedReportSagas from "./extended_report/sagas";
import watchFAQSagas from "./faq/sagas";
import watchFeedbacksSagas from "./feedbacks/sagas";
import watchGateTesterSagas from "./gate_tester/sagas";
import watchGatesSagas from "./gates/sagas";
import watchHostsSagas from "./hosts/sagas";
import watchIntegrationErrorsSagas from "./integration_errors/sagas";
import watchMarketsSagas from "./markets/sagas";
import watchPlaceSelectorSagas from "./place_selector/sagas";
import watchReportsSagas from "./reports/sagas";
import watchRoutesSagas from "./routes/sagas";
import watchUserSagas from "./user/sagas";
import watchApiStatesWidgetSagas from "./widgets/api_state/sagas";
import watchConversionsWidgetSagas from "./widgets/conversions/sagas";
import watchFilteredAirlinesWidgetSagas from "./widgets/filtered_airlines/sagas";

export default function* rootSaga(): Generator<AllEffect<ForkEffect<void>>, void, unknown> {
  yield all([
    fork(watchAirlinesProductivitySagas),
    fork(watchAirlinesSagas),
    fork(watchAlertsSagas),
    fork(watchAuctionSagas),
    fork(watchAuthSagas),
    fork(watchBookingsSagas),
    fork(watchClicksSagas),
    fork(watchContactPageSagas),
    fork(watchConversionsSagas),
    fork(watchCurrenciesSagas),
    fork(watchDebugSagas),
    fork(watchFeedbacksSagas),
    fork(watchGateTesterSagas),
    fork(watchGatesSagas),
    fork(watchHostsSagas),
    fork(watchMarketsSagas),
    fork(watchReportsSagas),
    fork(watchRoutesSagas),
    fork(watchUserSagas),
    fork(watchApiStatesWidgetSagas),
    fork(watchConversionsWidgetSagas),
    fork(watchFilteredAirlinesWidgetSagas),
    fork(watchExtendedReportSagas),
    fork(watchIntegrationErrorsSagas),
    fork(watchFAQSagas),
    fork(watchPlaceSelectorSagas),
  ]);
}
